import { gql } from "@apollo/client";

export const addOrganisation = gql`
  mutation addOrganisation($record: CreateOneOrganisationInput!) {
    organisation_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;
export const updateOrganisation = gql`
  mutation updateOrganisation($_id: MongoID!, $record: UpdateByIdOrganisationInput!) {
    organisation_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;